import Layout from '../../layouts/Layout';
import { Button } from '../../components/Button/Button';
import useGuide from '../../hooks/useGuide';

import SplashScreen from './components/SplashScreen';
import useSplashScreen from './components/SplashScreen/useSplashScreen';
import { Link } from 'react-router-dom';

const Home = () => {
  const { getCurrentAnimationClass } = useGuide(['createGame']);

  const { show, fadeOut, fadeOutTime } = useSplashScreen({
    timeBeforeFadeOut: 1000,
    fadeOutTime: 1000,
  });

  return (
    <>
      {show ? (
        <SplashScreen fadeOut={fadeOut} fadeOutTime={fadeOutTime} />
      ) : (
        <Layout>
          <div className="mt-2">
            <h1 className="title font-bold ">Quizzy</h1>
            <h1 className="title mb-3 font-bold ">Booze</h1>
            <h2 className="subtitle">Euer Trinkspiel</h2>
            <div className="max-w-52">
              <div className="bg-white rounded-lg p-2 mt-6 mb-3 text-black shadow-lg relative border-1 border-malibu">
                <p className="text-sm text-gray-500">Danke für</p>
                <p className="text-2xl font-bold text-orange-500">35.000</p>
                <p className="text-sm text-gray-500">gespielte Fragen!</p>
                <span className="absolute right-[-17px] top-[-17px] text-4xl">
                  🎉
                </span>
                <hr className="mt-2 mb-2 border-t  border-gray-300 shadow-sm" />
                <p className="text-sm text-gray-500">
                  Macht Quizzy Booze noch besser mit{' '}
                  <Link to="/feedback" className="underline">
                    Feedback
                  </Link>{' '}
                  und{' '}
                  <Link to="/frage-einreichen" className="underline">
                    Fragenvorschlägen
                  </Link>
                  !
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-1 flex-col items-center justify-end gap-y-4 pt-4">
            <Button
              type="link"
              to="/game/create"
              className={getCurrentAnimationClass('createGame')}
            >
              Spiel erstellen
            </Button>
            <Button type="link" to="/game/join">
              Spiel beitreten
            </Button>
          </div>
        </Layout>
      )}
    </>
  );
};

export default Home;
